export default __webpack_public_path__ + "static/media/CalaveraDeLaLuna.28cff739.jpg";